module.exports = {
	"Play": "Afspelen",
	"Pause": "Pauze",
	"Current Time": "Huidige tijd",
	"Duration Time": "Looptijd",
	"Remaining Time": "Resterende tijd",
	"Stream Type": "Streamtype",
	"LIVE": "LIVE",
	"Loaded": "Geladen",
	"Progress": "Status",
	"Fullscreen": "Volledig scherm",
	"Non-Fullscreen": "Geen volledig scherm",
	"Mute": "Geluid uit",
	"Unmute": "Geluid aan",
	"Playback Rate": "Weergavesnelheid",
	"Subtitles": "Ondertiteling",
	"subtitles off": "ondertiteling uit",
	"Captions": "Bijschriften",
	"captions off": "bijschriften uit",
	"Chapters": "Hoofdstukken",
	"Descriptions": "Beschrijvingen",
	"descriptions off": "beschrijvingen off",
	"You aborted the media playback": "U hebt de mediaweergave afgebroken.",
	"A network error caused the media download to fail part-way.": "De mediadownload is mislukt door een netwerkfout.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "De media kon niet worden geladen, vanwege een server- of netwerkfout of doordat het formaat niet wordt ondersteund.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "De mediaweergave is afgebroken vanwege beschadigde data of het mediabestand gebruikt functies die niet door uw browser worden ondersteund.",
	"No compatible source was found for this media.": "Voor deze media is geen ondersteunde bron gevonden.",
	"Play Video": "Video Afspelen",
	"Close": "Sluiten",
	"Modal Window": "Modal Venster",
	"This is a modal window": "Dit is een modaal venster",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Dit modaal venster kan gesloten worden door op Escape te drukken of de 'sluiten' knop te activeren.",
	", opens captions settings dialog": ", opent bijschriften instellingen venster",
	", opens subtitles settings dialog": ", opent ondertiteling instellingen venster",
	", opens descriptions settings dialog": ", opent beschrijvingen instellingen venster",
	", selected": ", selected"
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/nl.json
// module id = 596
// module chunks = 1